interface ScrollTargetInput {
  direction: "left" | "right";
  scrollLeft: number;
  clientWidth: number;
  scrollWidth: number;
  pinnedWidth: number;
}

/** Target `scrollLeft` for one click: half the visible scrollable width (minus pinned columns, or the full width if they fill it), clamped to the container's ends */
export function getScrollTarget({
  direction,
  scrollLeft,
  clientWidth,
  scrollWidth,
  pinnedWidth
}: ScrollTargetInput): number {
  const scrollableWidth = clientWidth - pinnedWidth;
  const step = (scrollableWidth > 0 ? scrollableWidth : clientWidth) / 2;
  const maxScrollLeft = Math.max(0, scrollWidth - clientWidth);
  const target = direction === "right" ? scrollLeft + step : scrollLeft - step;

  return Math.min(maxScrollLeft, Math.max(0, target));
}
